import { REHYDRATE } from 'redux-persist/constants';
import { put, all, takeLatest } from 'redux-saga/effects';
import actions, { apiActions } from './actions';

export function* getPulicConfigs() {
  yield put(apiActions.config.public.get());
}

function* configSagas() {
  yield all([
    takeLatest(actions.config.public.get().type, getPulicConfigs),
    takeLatest(REHYDRATE, getPulicConfigs)
  ]);
}

export default configSagas;



// WEBPACK FOOTER //
// ./src/state/modules/configuration/sagas.js